import { signOutUser, getSession } from '../libs/auth'
import { fetchStudent, createStudent } from '../libs/apiCalls';
import {
  LOGIN_REQUEST,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  CREDENTIALS_REQUEST,
  CREDENTIALS_SUCCESS,
  CREDENTIALS_FAILURE,
  SET_USER
} from './types';
import { debugLog } from "../libs/utilities";
import okta from "../config/okta";
import { Auth } from "aws-amplify";

/*
 * Authentication Actions
 */

/*export const requestLogin = () => {
  return {
    type: LOGIN_REQUEST,
    isFetching: true,
    isAuthenticated: false
  }
}; */

export const logoutUser = () => (dispatch) =>
    new Promise(function(resolve, reject) {
      dispatch(requestLogout());

      signOutUser().then((success) => {
        if(success)
          dispatch(receiveLogout());
        else
          throw new Error('Error logging out');
      }).catch(err => {
        dispatch(logoutError());
        reject(err);
      })
    });

const requestLogout = () => {
  return {
    type: LOGOUT_REQUEST,
    isFetching: true
  }
};

const receiveLogout = () => {
  return {
    type: LOGOUT_SUCCESS,
    isFetching: false,
    isAuthenticated: false,
    user: null
  }
};

const logoutError = (message) => {
  return {
    type: LOGOUT_FAILURE,
    isFetching: false,
    message
  }
};

export const authRequest = () => {
  return {
    type: AUTH_REQUEST
  }
};

export const authSuccess = () => {
  return {
    type: AUTH_SUCCESS
  }
};

export const authFailure = (message) => {
  return {
    type: AUTH_FAILURE,
    message
  }
};

export const getCredentials = (idToken, oktaUser) => {
  return async dispatch => {
    let user;
    try {
      debugLog(oktaUser);
      dispatch(credentialsRequest());
      // Check localstorage for credentials, if they don't exist, get them from AWS
      if(!await Auth.currentCredentials()) {
        await Auth.federatedSignIn(
          okta.oktaDomain,
          {
            token: idToken,
            expires_at: 3600 * 1000 + new Date().getTime()
          },
          {
            name: oktaUser.name,
            email: oktaUser.email,
            deltaId: oktaUser.deltaId
          }
        );
      }
      user = await Auth.currentAuthenticatedUser();
    } catch (e) {
      console.error(e);
      // Likely because we had credentials but they were expired or not set correctly
      debugLog('No User');
    }
    // Something happened above, lets get new credentials
    if (!user) {
      try {
        await Auth.federatedSignIn(
          okta.oktaDomain,
          {
            token: idToken,
            expires_at: 3600 * 1000 + new Date().getTime()
          },
          {
            name: oktaUser.name,
            email: oktaUser.email,
            deltaId: oktaUser.deltaId
          }
        );
        user = await Auth.currentAuthenticatedUser();
      } catch (e) {
        // We tried 2 ways, it ain't happening
        dispatch(credentialsFailure(e.message));
        console.error('AWS Error: ', e);
      }
    }
    if (user) {
      dispatch(credentialsSuccess());
    }
  }
};

export const credentialsRequest = () => {
  return {
    type: CREDENTIALS_REQUEST
  }
};

export const credentialsSuccess = () => {
  return {
    type: CREDENTIALS_SUCCESS
  }
};

export const credentialsFailure = (message) => {
  return {
    type: CREDENTIALS_FAILURE,
    message
  }
};

export const getOrCreateStudent = (identityId) => dispatch =>
  new Promise(async function(resolve, reject) {
    try {
      const result = await fetchStudent(identityId);
      const resultJson = await result.json();
      debugLog('getStudent result: ', resultJson);
      if (result.status === 200) {
        const student = resultJson.Item;
        dispatch(setUser(student));
        resolve(student);
      } else {
        const result = await createStudent(identityId);
        if (result.status === 200) {
          dispatch(setUser(result));
          resolve(result);
        } else {

        }
      }
    } catch (e) {
      console.error(e);
      reject(e);
    }
  });

export const setUser = (user) => {
  return {
    type: SET_USER,
    user
  }
};

export const authUser = () => dispatch =>
  new Promise(function (resolve, reject) {
    dispatch(authRequest());

    return getSession()
      .then(validSession => {
        if(validSession)
          dispatch(authSuccess());
        else
          dispatch(authFailure());
        resolve('Session Status: ' + validSession);
      }).catch(err => {
        dispatch(authFailure(err.message));
        reject(err);
      })
  });